import Vue from 'vue';
import isTakeOut from './isTakeOut';
const AlertTake= Vue.extend(isTakeOut);

let instance;


const open = function(tableNo,callback) {
  if (!instance) {
    instance = new AlertTake({
      el: document.createElement('div')
    });
  }

  instance.init();
  instance.clicked = callback;
  instance.tableNo =tableNo || '';
  instance.id = 0;


  if (instance.visible) return;
  document.body.appendChild(instance.$el);
  Vue.nextTick(() => {
    instance.visible = true;
  });
};

const close =function () {
  if (instance) {
    instance.visible = false;
  }
};

export default {
  open,
  close
}



// WEBPACK FOOTER //
// ./src/components/isTakeOut/index.js